import { useEffect, useState, useContext } from 'react';
import debounce from 'lodash/debounce';
import { ThemeContext } from 'styled-components';

const sizeMap = breakpoints => Object.entries(breakpoints).reduce((acc, [key, val]) => ({ ...acc,
  [key]: Number(val.replace('px', ''))
}), {});

export const DESKTOP_BREAKPOINTS = ['md', 'lg', 'xl'];
export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState('');
  const {
    breakpoints
  } = useContext(ThemeContext);

  const handleResize = () => {
    const {
      innerWidth
    } = window;
    const largestBreakpoint = Object.entries(sizeMap(breakpoints)).reduce( // @ts-ignore
    (largestFoundBreakpoint, [key, width]) => {
      // @ts-ignore
      if (largestFoundBreakpoint.width <= width && width < innerWidth) {
        return {
          key,
          width
        };
      }

      return largestFoundBreakpoint;
    }, {
      key: '',
      width: 0
    } // @ts-ignore
    ).key;
    setBreakpoint(largestBreakpoint);
  };

  const debouncedHandleResize = debounce(handleResize, 200);
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', debouncedHandleResize);
    return function cleanup() {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [debouncedHandleResize]);
  return breakpoint;
};